export default __webpack_public_path__ + "static/4-8749938cb63ea38d445e6f1374da3886.jpeg";